import {TournamentType} from '@/services/internal/tournament/types';

export const H2H_CATEGORIES: TournamentType[] = ['CASH', 'Z'];
